import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import { isUrl, urlToList } from '@/shared/utils';
import IconFont from '../IconFont';
import { MujiLink } from '@souche-f2e/muji';
import styles from './index.module.less';
import { getMenuMatches } from './utils';
import { dispatch } from '@@/store';
const { SubMenu } = Menu;
// Allow menu.js config icon as string or ReactNode
//   icon: 'setting',
//   icon: 'icon-geren' #For Iconfont ,
//   icon: 'http://demo.com/icon.png',
//   icon: <Icon type="setting" />,
const getIcon = (icon) => {
  if (typeof icon === 'string') {
    if (isUrl(icon)) {
      return (
        <Icon
          component={() => (
            <img src={icon} alt="icon" className={styles.icon} />
          )}
        />
      );
    }
    if (icon.startsWith('icon-')) {
      return <IconFont type={icon} />;
    }
    return <Icon type={icon} />;
  }
  return icon;
};
const conversionPath = (path) => {
  if (path && path.indexOf('http') === 0) {
    return path;
  }
  return `/${path || ''}`.replace(/\/+/g, '/');
};

class BaseMenu extends Component {
  constructor() {
    super(...arguments);
    const menuData = this.props.menuData;
    const isDocMenu = this.props.isDocMenu;

    this.getSelectedMenuKeys = (path) => {
      const { flatMenuKeys } = this.props;
      const pathList = urlToList(path).map((itemPath) =>
        getMenuMatches(flatMenuKeys, itemPath).pop()
      );
      const keyList = pathList.map(elem => {
        if (elem) {
          const selectItem = menuData.filter(e => e.path === elem)[0];
          if (selectItem) {
            return selectItem.key || selectItem.title;
          }
          return;
        } else {
          return;
        }
      });
      return keyList;
    };

    this.renderMenuItems = (items) => {
      if (!items) {
        return [];
      }
      return items
        .filter((item) => item.title)
        .map((item) => this.renderSubMenuOrItem(item))
        .filter((item) => item);
    };
    this.renderSubMenuOrItem = (item) => {
      if (
        Array.isArray(item.children) &&
        item.children.some((child) => !!child.title)
      ) {
        const title = item.icon ? (
          <span>
            {typeof item.icon === 'string' ? (
              <Icon type={item.icon} />
            ) : (
              item.icon
            )}
            <span>{item.title}</span>
          </span>
        ) : (
          item.title
        );
        return (
          <SubMenu title={title} key={item.title}>
            {this.renderMenuItems(item.children)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item key={item.key || item.title}>{this.renderMenuItemPath(item)}</Menu.Item>
      );
    };
    this.renderMenuItemPath = (item) => {
      const title = item.title;
      const itemPath = conversionPath(item.path);
      const icon = getIcon(item.icon);
      const { target } = item;

      // Is it a http link
      if (/^https?:\/\//.test(itemPath)) {
        return (
          <a href={itemPath} target={target}>
            {icon}
            <span>{title}</span>
          </a>
        );
      }
      if (isDocMenu) {
        // 文档菜单，点击后修改父组件state.menuPath
        return (
          <span>{title}</span>
        )
      }
      const { currentRoute } = this.props;

      return (
        <MujiLink
          to={itemPath}
          target={target}
          replace={itemPath === currentRoute.path}
        >
          {icon}
          <span>{title}</span>
        </MujiLink>
      );
    };
    /**
     * 广度优先遍历树形结构faq-menu-data数组
     */
    this.processLastMenuItems = (key, arr) => {
      const queue = [...arr];
      while (true) {
        const next = queue.shift();
        if (!next) {
          break;
        }
        if (next.title == key) {
          return next.docId;
        }
        next.children && queue.push(...next.children)
      }
    }
    /**
     * 按级搜索faq-menu-data数组，避免重名
     */
    this.processMenuDocId = (keyPath, arr) => {
      let queue = [...arr];
      // 返回分级的菜单层级
      return keyPath.reduce((docId, elem) => {
        for (const listIndex in queue) {
          if (queue[listIndex].title == elem) {
            queue = queue[listIndex].children;
            return docId === '' ? `${listIndex}` : `${docId},${listIndex}`;
          }
        }
      },'');
    }
    /**
     * 点击doc类型菜单项，传递breadcrumb给DocContent
     * 同时根据不同的菜单项docId发起GET请求对应列表项
     */
    this.handleClick = (e) => {
      if (isDocMenu) {
        const type = this.props.sideType;
        const keyPath = e.keyPath.reverse().join(' / ');
        this.props.setMenuItemKeyPath(keyPath);
        if (type) {
          const urlMap = `/${type}`
          dispatch.router.push(urlMap);
          const docId = this.processMenuDocId(e.keyPath, menuData);
          this.props.setDocId(docId);
        } else {
          const docId = this.processLastMenuItems(e.key, menuData);
          switch (docId) {
            case 'doc1':
              this.props.setDocId(0);
              break;
            case 'doc2':
              this.props.setDocId(1);
              break;
            case 'doc3':
              this.props.setDocId(2);
              break;
            case 'doc4':
              this.props.setDocId(3);
              break;
            case 'doc5':
              this.props.setDocId(4);
            default:
              break;
          }
        }
      }
      return;
    }
  }

  render() {
    const {
      className,
      style,
      mode,
      onOpenChange,
      menuData,
      isDocMenu,
      openKeys,
      collapsed,
      currentRoute: { path },
      theme
    } = this.props;
    
    let selectedKeys = this.getSelectedMenuKeys(path);
    let menuTheme = isDocMenu ? 'light' : 'dark';

    if(theme) menuTheme = theme;

    if (!selectedKeys.length && openKeys) {
      selectedKeys = [openKeys[openKeys.length - 1]];
    }
    return (
      <Menu
        className={className}
        style={style}
        theme={menuTheme}
        mode={mode}
        onOpenChange={onOpenChange}
        // selectedKeys={selectedKeys}
        onClick={this.handleClick}
        {...(openKeys && !collapsed
          ? {
              openKeys: openKeys.length === 0 ? [...selectedKeys] : openKeys,
            }
          : null)}
      >
        {this.renderMenuItems(menuData)}
      </Menu>
    );
  }
}

export default BaseMenu;
